// extracted by mini-css-extract-plugin
export default {"link":"style_link__vTebm","centerGrid":"style_centerGrid__d4Noy","img":"style_img__vad9s","namegame":"style_namegame__kJ1OV","center":"style_center__aheJ1"};